/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const OneStopAttachmentUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.ONE_STOP_ATTACHMENT} />;
};

export default OneStopAttachmentUploaderInput;
